module.exports = window.__bone_loader__;


//////////////////
// WEBPACK FOOTER
// ./packages/bone-web@0.2/node_modules/_@bone_loader@0.1.3@@bone/loader/loader.js
// module id = 2550
// module chunks = 4